<div class="flex" style="margin-top: 15px;" *ngIf="deviceCategories && deviceCategories.length > 0">
  <div class="card w-full">
    <div class="p-datatable p-component p-datatable-striped p-datatable-hoverable-rows">
      <p-table
        [(first)]="first"
        [(rows)]="rows"
        [value]="deviceCategories"
        [totalRecords]="totalDeviceCategories"
        [breakpoint]="'DATATABLE_BREAKPOINT' | appConfig"
        [paginator]="true"
        [rowsPerPageOptions]="[10,25,50]"
        [lazy]="true"
        (onPage)="onPageChange($event)"
      >
        <ng-template pTemplate="header">
          <tr>
            <th>{{'attribute.name' | transloco}}</th>
            <th>{{'attribute.description' | transloco}}</th>
          </tr>
        </ng-template>
        <ng-template pTemplate="body" let-category>
          <tr *ngIf="!loadingDeviceCategories">
            <td>
              <span class="p-column-title bold">{{'attribute.name' | transloco}}</span>
              {{category.name}}
            </td>
            <td>
              <span class="p-column-title bold">{{'attribute.description' | transloco}}</span>
              {{category.description}}
            </td>
          </tr>
          <tr *ngIf="loadingDeviceCategories">
            <td class="p-3 bold"><p-skeleton height="1em"></p-skeleton></td>
            <td class="p-3 bold"><p-skeleton height="1em"></p-skeleton></td>
          </tr>
        </ng-template>
        <ng-template pTemplate="summary">
          <div class="flex align-items-center justify-content-between" *ngIf="totalDeviceCategories == 0">
            {{'pagination.empty' | transloco}}
          </div>
          <div class="flex align-items-center justify-content-between" *ngIf="totalDeviceCategories > 0">
            Showing {{first+1}}
            to {{(first+rows) >= totalDeviceCategories ? totalDeviceCategories : (first+rows)}}
            of {{totalDeviceCategories}} {{totalDeviceCategories > 1 ? 'entries':'entry'}}
          </div>
        </ng-template>
      </p-table>
    </div>
  </div>
</div>
<div class="flex" style="margin-top: 15px;" *ngIf="deviceCategories && deviceCategories.length == 0">
  <div class="card w-full">
    <p class="text-xl text-center p-6 font-italic">{{'empty.deviceCategories' | transloco}}</p>
  </div>
</div>
<div class="flex" style="margin-top: 15px;" *ngIf="!deviceCategories">
  <div class="card w-full">
    <app-table-skeleton [rows]="14"></app-table-skeleton>
  </div>
</div>
